
import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { IWizardObjectOption, IWizardContent, instanceOfIWizardObjectReferable} from "../../../../../../../domain/format";
import { IItem } from "../../../../../../../domain/document/items";
import { EditingDocument } from "../../../..";
import { DocumentEditableMixin } from "../../../../mixins";
import { FatalIndicator } from "../common";
import { CheckedValueAccessor } from "../accessors";

@Component({
  components: {
    WizardContent: () => import("../WizardContent.vue"),  // 再帰的に呼ばれるコンポーネントは動的import要.(単一コンポーネントでの再帰ならname指定でも回避可能？)
    FatalIndicator,
  },
})
export default class ObjectSelectableContentOptionMixin extends Mixins(DocumentEditableMixin) {
  @Prop()
  content: IWizardObjectOption;

  @Prop({ default: false })
  disabled: boolean;

  data() {
    return {
      accessor: null as CheckedValueAccessor,
      error: "",
    };
  }
  accessor: CheckedValueAccessor;
  error: string;

  get text(): string {
    return this.content.text
      ? this.content.text
      : this.accessor.name();
  }

  get isChecked(): boolean {
    return this.accessor.get();
  }

  set isChecked(value: boolean) {
    this.updateItem(this.accessor.set(value), 0);
  }

  get item(): IItem {
    return this.readPropertyOrDefault(
      s => Enumerable.from((s as EditingDocument).itemSets[0].items)
        .firstOrDefault(i => i && (i.id === this.content.objectIdentifier.id)),
      null);
  }

  get optionalContent(): IWizardContent {
    return this.content.content;
  }

  get isFatal(): boolean {
    return !this.accessor;
  }

  get identifierId(): string {
    return (instanceOfIWizardObjectReferable(this.content) && !!this.content.objectIdentifier.id)
      ? this.content.objectIdentifier.id
      : "未指定";
  }

  mounted() {
    this.initialize(this.item);
  }

  @Watch("item")
  onItemUpdated(newValue: IItem) {
    this.initialize(newValue);
  }

  initialize(newValue: IItem) {
    try {
      this.accessor = new CheckedValueAccessor(newValue);
      this.accessor.validate();
      this.error = "";
    } catch (e) {
      this.accessor = null;
      this.error = e.message;
    }
  }
}
